import {isMiitelInCall} from 'helpers/miitelWidget';

// リリースしても、開いたままのタブはブラウザを更新するまで古い JavaScript で動き続ける(#17214)。
// サーバーは GraphQL のレスポンスに、いま配っているフロントのバージョンを X-App-Revision で付ける。
// 画面を読み込んだときの値(meta タグ)と違えば、リード・営業リストの詳細を開いたときにページを読み込み直す。

const RELOADED_AT_KEY = 'appRevisionReloadedAt';
const RELOADED_FROM_KEY = 'appRevisionReloadedFrom';
// デプロイの途中はサーバーによってバージョンが違うので、続けて読み込み直さないようにする
const RELOAD_INTERVAL = 5 * 60 * 1000;

const pageRevision =
  document
    .querySelector<HTMLMetaElement>('meta[name="app-revision"]')
    ?.getAttribute('content') || null;

// 一度でも違いを検知したら、検知した状態を保つ
let hasNewRevision = false;

// 読み込み直した直後の最初のリクエストで、サーバーのログに残す
let reloadedFrom: string | null = null;
try {
  reloadedFrom = sessionStorage.getItem(RELOADED_FROM_KEY);
  sessionStorage.removeItem(RELOADED_FROM_KEY);
} catch {
  // sessionStorage が使えない環境では記録しない
}

export const fetchWithAppRevision: typeof fetch = (input, init) => {
  const headers = new Headers(init?.headers);
  if (reloadedFrom) {
    headers.set('X-App-Reloaded-From', reloadedFrom);
    reloadedFrom = null;
  }

  return fetch(input, {...init, headers}).then((response) => {
    const serverRevision = response.headers.get('X-App-Revision');
    if (pageRevision && serverRevision && serverRevision !== pageRevision)
      hasNewRevision = true;
    return response;
  });
};

// 最後に開いた詳細の ID。表示中の詳細が描画し直されただけのときは、入力中かもしれないので読み込み直さない
let lastId: string | null = null;

// id は、開いた詳細の ID
export const reloadIfNewRevision = (id: string) => {
  if (!id || id === lastId) return;
  lastId = id;

  if (!hasNewRevision) return;
  // URL を変えずに詳細を開く画面では、読み込み直すと詳細が閉じてしまう
  if (!window.location.pathname.includes(id)) return;
  // 読み込み直すと電話が切れる
  if (isMiitelInCall()) return;

  try {
    const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY));
    if (Date.now() - reloadedAt < RELOAD_INTERVAL) return;
    sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    sessionStorage.setItem(RELOADED_FROM_KEY, pageRevision);
  } catch {
    // 読み込み直しを繰り返さない保証ができないので、何もしない
    return;
  }

  window.location.reload();
};
